import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a1c07758be93c00146033dc_1780228910239/fightarena/src/app/game-arena/components/GameArenaContent.tsx");
